import { Stack } from '@ltvco/refresh-lib/theme';
import { UploadPhotoInstruction } from './UploadPhotoInstruction';
import { DamageAnalyzerResultCard } from './DamageAnalyzerResultCard';
import { ToolCallParameters } from '@ltvco/refresh-lib/api';
import { RetrySearchInstruction } from '../components/RetrySearchInstruction';

type DamageAnalyzerContentProps = {
  onSendMessage?: (message?: string, imageBase64?: string) => void;
  hasConversationStarted: boolean;
  firstPhotoDamageEstimate: ToolCallParameters | null | undefined;
  imageToAnalyze: string | null;
  setImageToAnalyze: (image: string) => void;
  onImageErrorChange: (hasError: boolean) => void;
  hasImageError: boolean;
  onClearImage: () => void;
};
export const DamageAnalyzerContent = ({
  onSendMessage,
  hasConversationStarted,
  firstPhotoDamageEstimate,
  imageToAnalyze,
  setImageToAnalyze,
  onImageErrorChange,
  onClearImage,
  hasImageError,
}: DamageAnalyzerContentProps) => {
  return (
    <Stack alignItems="center" gap={1}>
      <UploadPhotoInstruction
        setImageToAnalyze={setImageToAnalyze}
        onSendMessage={onSendMessage}
        hasImageToAnalyze={Boolean(imageToAnalyze) || hasConversationStarted}
        onImageErrorChange={onImageErrorChange}
      />
      {firstPhotoDamageEstimate && !hasImageError && (
        <>
          <DamageAnalyzerResultCard
            estimate={firstPhotoDamageEstimate}
            imageToAnalyze={imageToAnalyze}
          />
          <RetrySearchInstruction onRetrySearch={onClearImage} />
        </>
      )}
    </Stack>
  );
};
